import React, {Component} from "react";
import {SortableTableHeader} from "../../components/table/sortable-table-header";

export default class ContractTradesTableHeader extends Component {

  static Layout = [
    { column: "tradeDate", name: "Trade Date" },
    { column: "periodName", width: 2, name: "Period"  },
    { column: "loadTypeName", name: "type" },
    { column: "tradedCapacity", name: "Traded Capacity" },
    { column: "tradedVolume", name: "Traded Volume" },
    { column: "tradePrice", name: "Price Paid" },
    { column: "tradeValue", width: 2, name: "Trade Value" },
    { column: "tradeTypeName", name:"Trade Type" }
  ];

  render() {
    return (
        <SortableTableHeader column={this.props.column} direction={this.props.direction} onChangeSort={this.props.onChangeSort} headings={ContractTradesTableHeader.Layout}/>
    )
  }
}